<dialog-popup
  #feedbackConfirmationDialog
  [title]="'feedback-confirmation.title' | translate"
  [showCloseButton]="false"
  [primaryButtonName]="'common.continue' | translate"
  [secondaryButtonName]="'common.cancel' | translate"
  (primaryButtonClicked)="continueToFeedback()"
  (secondaryButtonClicked)="closeFeedbackConfirmation()"
  (dialogEscapeCloseClicked)="closeFeedbackConfirmation()"
  (outsideContentClicked)="closeFeedbackConfirmationDialog()"
>
  <!-- prettier-ignore -->
  <p autofocus tabindex="-1" class="m-0 max-w-[414px] text-left text-sm leading-[1.42] outline-none ring-0 focus:!outline-none focus:!ring-0 focus-visible:!outline-none focus-visible:!ring-0">
    {{ 'feedback-confirmation.body-1' | translate }}<strong>NG Portal</strong>{{ 'feedback-confirmation.body-2' | translate }}<strong>{{ 'common.continue' | translate }}</strong>{{ 'feedback-confirmation.body-3' | translate }}<a class="text-[#007bc0] hover:underline outline-none ring-0 focus:!outline-none focus:!ring-0 focus-visible:!outline-none focus-visible:!ring-0" routerLink="/apps" (click)="closeFeedbackConfirmationDialog()">App Finder</a>{{ 'feedback-confirmation.body-4' | translate }}
  </p>
</dialog-popup>
